export default {
    MMDDYYYY: 'mmddyyyy',
    DDMMYYYY: 'ddmmyyyy',
    YYYYMMDD: 'yyyymmdd'
};
